import styled from 'styled-components';
import { rem } from 'polished';
import { ParagraphStyle } from 'elements/Paragraph/styled';
import { colors } from 'core/theme';

export const SitemapList = styled.ol`
  ${props => ParagraphStyle({ size: 'medium' })};
    font-size: ${rem(18)};
    margin-bottom: 1em;
    padding-left: 2em;
    -webkit-padding-start: 2em;

    list-style: none;
    margin: 0;
    padding-left: 0;

    color: ${colors.primary};
    font-weight: 500;

    ol {
      margin-top: 0.5rem !important;
      margin-bottom: 1rem !important;
      padding-left: 1rem !important;
    }

    & > li > ol {
      color: ${colors.text};
      font-size: 1rem;
      font-weight: 400;
      padding-left: 1em;

      & > li > ol {
        color: ${colors.lightText};
      }
    }

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/Sitemap/styled.js